import { render, staticRenderFns } from "./PanelGroupDataList.vue?vue&type=template&id=01989cd2"
import script from "./PanelGroupDataList.vue?vue&type=script&lang=js"
export * from "./PanelGroupDataList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports